(() => {
  if(globalThis.frQuizAttributionReady)return;
  globalThis.frQuizAttributionReady=true;
  const getAttribution=()=>{try{const value=JSON.parse(sessionStorage.getItem('fr_quiz_attribution'));return value?.expires>Date.now()?value:null;}catch{return null;}};
  const attachProperties=event=>{
    const button=event.target.closest?.('button[type="submit"]');
    const form=event.type==='submit'?event.target:button?.form;
    const component=form?.closest?.('product-form-component')||button?.closest?.('product-form-component');
    if(!form||!component)return;
    form.querySelectorAll('input[data-fr-quiz-attribution]').forEach(input=>input.remove());
    if(globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
    const attribution=getAttribution();if(!attribution||String(component.dataset.productId)!==attribution.product_id)return;
    for(const [key,value]of Object.entries({_fr_quiz_version:attribution.version,_fr_quiz_session:attribution.id,_fr_quiz_position:String(attribution.position)})){
      const name='properties['+key+']';let input=form.querySelector('input[name="'+name+'"]');if(!input){input=document.createElement('input');input.type='hidden';input.name=name;input.dataset.frQuizAttribution='true';form.append(input);}input.value=value;
    }
  };
  globalThis.addEventListener('submit',attachProperties,true);
  globalThis.addEventListener('click',attachProperties,true);
  document.addEventListener('shopify:cart:lines-update',event=>{
    if(globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
    const attribution=getAttribution();if(!attribution)return;
    if(event.action!=='add')return;
    const pending=event;
    if(!pending?.promise)return;
    pending.promise.then(result=>{
      if(globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true||result?.detail?.didError)return;
      if(result?.detail?.source!=='product-form-component'||String(result.detail.productId)!==attribution.product_id)return;
      const variant=event.lines?.[0]?.merchandiseId?.split('/').pop();
      if(!variant)return;
      const item=result.detail.items?.find(item=>String(item.variant_id)===String(variant));
      if(!item)return;
      const properties={quiz_version:attribution.version,quiz_session_id:attribution.id,product_id:attribution.product_id,variant_id:String(variant),recommendation_position:attribution.position};
      if(typeof globalThis.gtag==='function')globalThis.gtag('event','quiz_add_to_cart',{send_to:'G-313L3SK2PY',...properties});
      else{globalThis.dataLayer=globalThis.dataLayer||[];globalThis.dataLayer.push({event:'quiz_add_to_cart',...properties});}
      try{globalThis.Shopify?.analytics?.publish?.('quiz_add_to_cart',properties)?.catch?.(()=>{});}catch{}
      if(globalThis.Shopify?.customerPrivacy?.thirdPartyMarketingAllowed?.()===true&&typeof globalThis.fbq==='function')globalThis.fbq('trackCustom','quiz_add_to_cart',properties);
      fetch((globalThis.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{fr_quiz_version:attribution.version,fr_quiz_session:attribution.id,fr_quiz_position:String(attribution.position)}})}).catch(()=>{});
    }).catch(()=>{});
  });
})();
